import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" id=\"error\">\n    <!-- Generator: sketchtool 47.1 (45422) - http://www.bohemiancoding.com/sketch -->\n    <title>91A24BED-CE89-4E3A-A7F2-D19B1CE08E56</title>\n    <desc>Created with sketchtool.</desc>\n    <defs></defs>\n    <g id=\"error_Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"error_64/error\">\n            <path d=\"M32,60 C16.536027,60 4,47.463973 4,32 C4,16.536027 16.536027,4 32,4 C47.463973,4 60,16.536027 60,32 C60,47.463973 47.463973,60 32,60 Z M28,16 L28,34 C28,36.209139 29.790861,38 32,38 C34.209139,38 36,36.209139 36,34 L36,16 C36,13.790861 34.209139,12 32,12 C29.790861,12 28,13.790861 28,16 Z M32,50 C34.209139,50 36,48.209139 36,46 C36,43.790861 34.209139,42 32,42 C29.790861,42 28,43.790861 28,46 C28,48.209139 29.790861,50 32,50 Z\" id=\"error_shape\" fill=\"#EE1D1D\" />\n            <g id=\"error_icon_grid\"></g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/error.svg
// module id = 510
// module chunks = 1